<span class="navbar__divider"></span>
<div class="onboarding-progress">
  <div class="onboarding-progress__body">
    <h1 class="onboarding-progress__title d-md-none d-lg-inline">
      Set Up Airbrake
    </h1>
    <div class="progress-wrap progress-wrap--small">
      <ngb-progressbar
        class="progress"
        type="success"
        [max]="totalCount()"
        [value]="completedCount()"
      ></ngb-progressbar>
      <div>&nbsp; {{ completedCount() }} of {{ totalCount() }}</div>
      <span class="ab-caret-right"></span>
    </div>
  </div>
  <ab-onboarding-callout
    [className]="'ShowOnboardingChecklist'"
    [project]="project"
  ></ab-onboarding-callout>
</div>
